import React from 'react'
import { Dialog, DialogTemplateType } from 'primereact/dialog';
import './ControlDialogBox.scss'

interface ControlDialogBoxPropTypes {
    dialogVisibile: boolean,
    onDialogBoxHide: () => void;
    IconPath: string,
    subHeading: string,
    subHeadingColor:string,
    msgText: string,

    footerTemplate:DialogTemplateType
}

export const ControlDialogBox = (props: ControlDialogBoxPropTypes) => {
    const {
        dialogVisibile,
        IconPath,
        subHeading,
        subHeadingColor,
        msgText,
        footerTemplate,
        onDialogBoxHide,
       
    } = props;


    
    return (
        <Dialog
            visible={dialogVisibile}
            className='template-dialog'
            onHide={() => onDialogBoxHide()}
            footer={footerTemplate}
            style={{ width: "35%" }}
        >
            <div className='dialog-body'>
                <div className='dialog-title'>
                    <img className='notification-icon' src={IconPath} alt={IconPath} />
                    <p style={{ marginBottom: "5px",color: `${subHeadingColor}` }}>{subHeading}</p>
                    <p style={{
                        color: "#404D61",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "500",
                        marginBottom: "0px",
                        maxWidth: "60%"
                    }}>{msgText}</p>
                </div>
            </div>
        </Dialog>
    )
}
